/*
 * Hero de produto (carrossel) - comportamento apenas (sem CSS via JS).
 * Move o track por translateX e atualiza barras/contador. Com autoplay, o avanco e
 * disparado pelo fim da animacao de preenchimento da barra ativa (estilo stories),
 * o que mantem barra e troca de slide perfeitamente sincronizadas; o hover/foco
 * pausa o preenchimento (e, por consequencia, o avanco) via classe.
 */
(function () {
  /**
   * @param {number} n
   * @returns {string}
   */
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /**
   * Inicializa uma instancia da section (o container [data-hero-pslide]).
   * @param {Element} root
   */
  function setupHeroSlideshow(root) {
    var track = /** @type {HTMLElement} */ (root.querySelector('[data-track]'));
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    var counter = root.querySelector('[data-counter]');
    var total = slides.length;

    if (!track || total <= 1) {
      return;
    }

    var current = 0;
    var autoplay = root.hasAttribute('data-autoplay');

    function render() {
      track.style.transform = 'translateX(' + (-100 * current) + '%)';

      dots.forEach(function (dot, i) {
        var isActive = i === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateCounter() {
      if (counter) {
        counter.textContent = pad(current + 1) + ' / ' + pad(total);
      }
    }

    /** @param {number} index */
    function goTo(index) {
      current = (index + total) % total;
      render();
      updateCounter();
    }

    /** @param {number} index */
    function goToBounded(index) {
      current = Math.max(0, Math.min(total - 1, index));
      render();
      updateCounter();
    }

    function next() {
      goTo(current + 1);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
      });
    });

    // ---- Arrasto por toque (mobile): segue o dedo e da snap no slide ----
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var slideWidth = 0;
    var dragging = false; // gesto horizontal confirmado
    var decided = false; // ja decidimos o eixo deste gesto

    /** @param {TouchEvent} event */
    function onTouchStart(event) {
      var touch = event.touches[0];
      if (!touch) {
        return;
      }
      startX = touch.clientX;
      startY = touch.clientY;
      deltaX = 0;
      dragging = false;
      decided = false;
      slideWidth = root.getBoundingClientRect().width;
    }

    /** @param {TouchEvent} event */
    function onTouchMove(event) {
      var touch = event.touches[0];
      if (!touch) {
        return;
      }
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;

      if (!decided) {
        // So vira swipe se o movimento horizontal dominar; senao deixa a pagina rolar.
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) {
          return;
        }
        decided = true;
        dragging = Math.abs(dx) > Math.abs(dy);
        if (dragging) {
          track.classList.add('is-dragging');
          root.classList.add('is-paused');
        }
      }

      if (!dragging) {
        return;
      }

      deltaX = dx;
      var basePx = -current * slideWidth;
      var minPx = -(total - 1) * slideWidth;
      var targetPx = basePx + deltaX;
      // Resistencia nas bordas (nao ha slide alem da primeira/ultima no arrasto manual).
      if (targetPx > 0) {
        targetPx = targetPx * 0.3;
      } else if (targetPx < minPx) {
        targetPx = minPx + (targetPx - minPx) * 0.3;
      }
      track.style.transform = 'translateX(' + targetPx + 'px)';
    }

    function onTouchEnd() {
      if (!dragging) {
        return;
      }
      track.classList.remove('is-dragging');
      root.classList.remove('is-paused');

      var threshold = slideWidth * 0.2;
      if (deltaX <= -threshold) {
        goToBounded(current + 1);
      } else if (deltaX >= threshold) {
        goToBounded(current - 1);
      } else {
        render();
      }
      dragging = false;
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: true });
    track.addEventListener('touchend', onTouchEnd);
    track.addEventListener('touchcancel', onTouchEnd);

    if (autoplay) {
      // O avanco acontece quando a barra ativa termina de preencher. Como apenas a
      // barra ativa anima, so esse animationend dispara.
      root.addEventListener('animationend', function (event) {
        if (/** @type {AnimationEvent} */ (event).animationName === 'hero-pslide-fill') {
          next();
        }
      });

      function pause() {
        root.classList.add('is-paused');
      }
      function resume() {
        root.classList.remove('is-paused');
      }

      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', resume);
    }

    render();
    updateCounter();
  }

  /** @param {(Document|Element)} [scope] */
  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-hero-pslide]');
    roots.forEach(function (node) {
      setupHeroSlideshow(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Editor de temas: a Shopify re-renderiza a section (DOM novo) ao editar; reinicia ali.
  document.addEventListener('shopify:section:load', function (event) {
    init(/** @type {Element} */ (event.target));
  });
})();
